import React from 'react';
import '../styles/style.css';

let abc;
const threeBarClick =() =>{
 abc= true;
 return abc;
}
function Header(props) {
    return (
        <div className='header'>
            <a href ='/' className='logo'>Imaginary</a>
            <div className='header-right'>
                <a href='/clones'>Clones</a>
                <a href='/gameX'>GameX</a>
                <a href='/drawings'>Drawings</a>
                <div className='three-bar' style={{'cursor':'pointer'}} onClick={()=>threeBarClick}>
                <div className='bar'></div>
                <div className='bar'></div>
                <div className='bar'></div>
                </div>
            </div>
            {abc && console.log(abc)}
        </div>
    );
}

export default Header;